import { includes, isFunction } from 'lodash'
import { setCookie, getHeader, serializePayload } from './auth'
import { i18n } from '../i18n'
import { AuthRegistrationType } from '../types/common'

// 환경변수 문제가 있어 하드코딩합니다.
const FACEBOOK_STAGING = '131221094984062'
const FACEBOOK_PRODUCTION = '309479342402963'

export const loadFacebookScript = (d: Document, s: string, id: string) => {
  const languages = {
    en: 'en_US',
    ko: 'ko_KR',
  }

  // 환경변수 문제가 있어 하드코딩합니다.
  const facebookAppId = includes(['classic.ondemandkorea.com', 'www.ondemandkorea.com'], window.location.hostname) ? FACEBOOK_PRODUCTION : FACEBOOK_STAGING

  let js,
    fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = `https://connect.facebook.net/${
    languages[i18n.language]
  }/sdk.js#xfbml=1&version=v6.0&appId=${facebookAppId}&autoLogAppEvents=1`
  fjs.parentNode.insertBefore(js, fjs)
}

export const setFacebookCookie = (response: facebook.StatusResponse) => {
  const isFacebookConnected = includes(['connected', 'authorization_expired', 'not_authorized'], response.status)
  setCookie('is_facebook_connected', isFacebookConnected ? '0' : '1')
}

const facebookRegistrationSuccess = (data, onRegistraion) => {
  console.log('facebookRegistrationSuccess: data', data)

  if (isFunction(onRegistraion)) {
    onRegistraion(data)
  } else {
    if (data.next) {
      window.location.href = data.next
    } else {
      window.location.reload()
    }
  }
}

const registrationUrl = {
  [AuthRegistrationType.INHOUSE]: '/includes15/facebook-registration',
  [AuthRegistrationType.OAUTH2]: '/oauth2/facebook-registration',
}

export const facebookRegistration = async ({
  registrationType,
  response,
  nextPage,
  onRegistration,
}: {
  registrationType: AuthRegistrationType
  response: facebook.StatusResponse
  nextPage: string
  onRegistration?: (data: { result: string; message: string; next?: string }) => void
}) => {
  response.authResponse['next'] = nextPage
  const res = await fetch(registrationUrl[registrationType], {
    method: 'POST',
    credentials: 'same-origin',
    headers: getHeader(),
    body: serializePayload(response.authResponse),
  })
  const data = await res.json()
  facebookRegistrationSuccess(data, onRegistration)
}
